import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=4c3c424c&scoped=true&lang=pug&"
var script = {}
import style0 from "./cell.vue?vue&type=style&index=0&id=4c3c424c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3c424c",
  null
  
)

export default component.exports